"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetQrCodeOptions = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
/* istanbul ignore file @preserve -- static */

const useGetQrCodeOptions = () => {
  const theme = (0, _mui.useTheme)();
  return (0, _react.useMemo)(() => ({
    type: 'svg',
    dotsOptions: {
      color: theme.palette.common.black
    },
    imageOptions: {
      crossOrigin: 'anonymous',
      margin: 5
    }
  }), [theme]);
};
exports.useGetQrCodeOptions = useGetQrCodeOptions;
